/* eslint-disable */
const hash = {
  "en-US": "6f10eef2",
  "de-DE": "0bafe944",
  "es-ES": "2966a325",
  "fr-FR": "74a492c9",
  "id-ID": "e7026165",
  "it-IT": "896a79c5",
  "jp-JP": "5a1048e4",
  "ko-KO": "80e88d03",
  "nl-NL": "d832c9aa",
  "pl-PL": "b325be52",
  "pt-PT": "ba04fe82",
  "ru-RU": "29f10620",
  "sv-SE": "5592ad7a",
  "tr-TR": "4f4bae7d",
  "vi-VN": "c94dd0ce",
  "zh-CN": "9c50cb93",
  "zh-TW": "9d83091d",
  "avatars": "d2cf8f77",
  "control": "8fcf61a7",
  "custom-ai_companion": "dc602c48",
  "plan-details": "289dbc4f",
  "gov-EN": "def7f73e",
  "en-GB": "d7f2a1ce"
}
export default hash
